import $ from 'jquery';
$(document).ready(function () {
  sliderIndustries();
});

function sliderIndustries() {
  $('.js-slider-industries').slick({
    dots: true,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
}
